var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "40px",
    viewBox: "0 0 23 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-V4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-5",
    fill: "#BDBDBD",
    transform: "translate(11.313131, 37.777778) rotate(-180.000000) translate(-11.313131, -37.777778) ",
    cx: 11.3131313,
    cy: 37.7777778,
    rx: 11.3131313,
    ry: 2.22222222
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.404040404,23.0245855 C0.404040404,23.7274196 0.2597402,39.1919192 11.2409812,39.1919192 C22.2222222,39.1919192 22.2222222,23.8764103 22.2222222,23.0245855 C22.2222222,22.1727607 20.2291941,20.6060606 11.2105282,20.6060606 C2.19186235,20.6060606 0.404040404,22.3217513 0.404040404,23.0245855 Z",
    id: "Path-18-Copy-2",
    fill: "#BDBDBD",
    transform: "translate(11.313131, 29.898990) rotate(-180.000000) translate(-11.313131, -29.898990) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82852839,27.4901648 C2.82852839,27.4901648 2.71216487,38.3838384 11.2450574,38.3838384 C19.7779498,38.3838384 19.7979798,27.4901648 19.7979798,27.4901648 C19.7979798,27.4901648 18.309009,26.6666667 11.3011211,26.6666667 C4.29323312,26.6666667 2.82852839,27.4901648 2.82852839,27.4901648 Z",
    id: "Path-18-Copy-3",
    fill: "#F0F0F0",
    transform: "translate(11.313131, 32.525253) rotate(-180.000000) translate(-11.313131, -32.525253) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    fill: "#F0F0F0",
    cx: 11.3131313,
    cy: 24.040404,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.405966954,2.02020202 C0.308355074,14.6801347 3.91999465,21.010101 11.2408857,21.010101 C18.5617767,21.010101 22.2222222,14.6801347 22.2222222,2.02020202 L0.405966954,2.02020202 Z",
    id: "Path-18-Copy-4",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.405966954,2.02020202 C0.308355074,4.82721956 3.91999465,6.23072834 11.2408857,6.23072834 C18.5617767,6.23072834 22.2222222,4.82721956 22.2222222,2.02020202 L0.405966954,2.02020202 Z",
    id: "Path-18-Copy-4",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-7",
    fill: "#BDBDBD",
    transform: "translate(11.313131, 2.222222) rotate(-180.000000) translate(-11.313131, -2.222222) ",
    cx: 11.3131313,
    cy: 2.22222222,
    rx: 11.3131313,
    ry: 2.22222222
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6969697,19.7979798 L9.6969697,19.7979798 L9.6969697,19.7979798 L12.9292929,19.7979798 C12.5682498,20.6905612 11.5519862,21.1214581 10.6594048,20.7604149 C10.2214395,20.5832609 9.87412372,20.2359451 9.6969697,19.7979798 Z",
    id: "Path-19-Copy",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23232323,14.5454545 C4.80952478,18.444622 7.54138115,20.3279674 11.4278923,20.1954906 C15.3144035,20.0630138 17.9697525,18.1796684 19.3939394,14.5454545 L3.23232323,14.5454545 Z",
    id: "Path-18-Copy-5",
    fill: "#F0F0F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.bd32af5ad7d73a255e2c9a822f5067fe.svg";
export { ForwardRef as ReactComponent };